export enum FormMode {

  NEW = 'new',
  EDIT = 'edit'

}
